import { initContract } from "@ts-rest/core";
import { z } from "zod";

import {
  AddCompaniesToTechnologyResponseType,
  AddContactsToTechnologyResponseType,
  ArchiveTechnologyResponseType,
  CreateNewTechnologyResponseType,
  CreateTechnologyFromCompanyIdsResponseType,
  CreateTechnologyFromContactIdsResponseType,
  FindAllTechnologiesByUserIdResponseType,
  FindTechnologyResponseType,
  GetPortfolioPatentsResponseType,
  RemoveCompaniesFromTechnologyResponseType,
  RemoveContactsFromTechnologyResponseType,
  UpdateTechnologyResponseType,
} from "@src/resources/portfolio/portfolio.service";

const c = initContract();

const index = c.router({
  addCompaniesToTechnology: {
    body: z.object({
      companyIds: z.array(z.string()),
      searchId: z.string().nullable().optional(),
    }),
    method: "POST",
    path: "/portfolio/add-companies-to-technology/:technologyId",
    pathParams: z.object({
      technologyId: z.string(),
    }),
    responses: {
      200: c.type<AddCompaniesToTechnologyResponseType>(),
    },
  },
  addContactsToTechnology: {
    body: z.object({
      contactIds: z.array(z.string()),
      searchId: z.string().nullable().optional(),
    }),
    method: "POST",
    path: "/portfolio/add-contacts-to-technology/:technologyId",
    pathParams: z.object({
      technologyId: z.string(),
    }),
    responses: {
      200: c.type<AddContactsToTechnologyResponseType>(),
    },
  },
  archiveTechnology: {
    body: z.union([z.null(), z.object({})]),
    method: "POST",
    path: "/portfolio/archive-technology/:technologyId",
    pathParams: z.object({
      technologyId: z.string(),
    }),
    responses: {
      200: c.type<ArchiveTechnologyResponseType>(),
    },
  },
  createTechnology: {
    body: z.object({
      description: z.string().optional(),
      name: z.string(),
    }),
    method: "POST",
    path: "/portfolio/create-technology",
    responses: {
      200: c.type<CreateNewTechnologyResponseType>(),
    },
  },
  createTechnologyFromCompanyIds: {
    body: z.object({
      companyIds: z.array(z.string()),
      description: z.string().optional(),
      name: z.string(),
      searchId: z.string().nullable().optional(),
    }),
    method: "POST",
    path: "/portfolio/create-technology-from-company-ids",
    responses: {
      200: c.type<CreateTechnologyFromCompanyIdsResponseType>(),
    },
  },
  createTechnologyFromContactIds: {
    body: z.object({
      contactIds: z.array(z.string()),
      description: z.string().optional(),
      name: z.string(),
      searchId: z.string().nullable().optional(),
    }),
    method: "POST",
    path: "/portfolio/create-technology-from-contact-ids",
    responses: {
      200: c.type<CreateTechnologyFromContactIdsResponseType>(),
    },
  },
  findAllTechnologiesByUserId: {
    method: "GET",
    path: "/portfolio/list",
    responses: {
      200: c.type<FindAllTechnologiesByUserIdResponseType>(),
    },
  },

  findTechnology: {
    method: "GET",
    path: "/portfolio/read/:technologyId",
    pathParams: z.object({
      technologyId: z.string(),
    }),

    responses: {
      200: c.type<FindTechnologyResponseType>(),
    },
  },

  removeCompaniesFromTechnology: {
    body: z.object({
      companyIds: z.array(z.string()),
    }),
    method: "POST",
    path: "/portfolio/remove-companies/:technologyId",
    pathParams: z.object({
      technologyId: z.string(),
    }),
    responses: {
      200: c.type<RemoveCompaniesFromTechnologyResponseType>(),
    },
  },
  removeContactsFromTechnology: {
    body: z.object({
      contactIds: z.array(z.string()),
    }),
    method: "POST",
    path: "/portfolio/remove-contacts/:technologyId",
    pathParams: z.object({
      technologyId: z.string(),
    }),
    responses: {
      200: c.type<RemoveContactsFromTechnologyResponseType>(),
    },
  },
  updateTechnology: {
    body: z.object({
      description: z.string().optional(),
      name: z.string(),
    }),
    method: "POST",
    path: "/portfolio/update-technology/:technologyId",
    pathParams: z.object({
      technologyId: z.string(),
    }),
    responses: {
      200: c.type<UpdateTechnologyResponseType>(),
    },
  },
});

export default index;
